/* tslint:disable */
/* eslint-disable */
/**
 * Keyops CEP
 * Customer Engagement Platform API documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ChartOrderBy {
    ALPHABETICALASC = 'ALPHABETICAL_ASC',
    ALPHABETICALDESC = 'ALPHABETICAL_DESC',
    VALUEASC = 'VALUE_ASC',
    VALUEDESC = 'VALUE_DESC',
    INITIAL = 'INITIAL'
}

